import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/pages/blogs/BlogsPage.jsx");
